import React from 'react';
import ProjectsContainer from './ProjectsContainer';

function ProjectsSection(props) {
    // Use the new API-based container if no specific props are passed
    // This maintains backward compatibility while enabling API integration
    return (
        <ProjectsContainer 
            numberOfStories={props.numberOfStories}
            storiesPerPage={props.storiesPerPage}
            load={props.load}
            type={props.type}
        />
    );
}

export default ProjectsSection;
